import { useEffect, useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { scrollToForm } from "../config";

export const StickyCTA = () => {
  const [show, setShow] = useState(false);

  useEffect(() => {
    let formVisible = true;
    let pastHero = false;
    const update = () => setShow(pastHero && !formVisible);
    const onScroll = () => {
      pastHero = window.scrollY > window.innerHeight * 0.85;
      update();
    };
    const form = document.getElementById("hero-form");
    const obs = new IntersectionObserver(
      ([entry]) => {
        formVisible = entry.isIntersecting;
        update();
      },
      { threshold: 0.15 }
    );
    if (form) obs.observe(form);
    window.addEventListener("scroll", onScroll, { passive: true });
    onScroll();
    return () => {
      obs.disconnect();
      window.removeEventListener("scroll", onScroll);
    };
  }, []);

  return (
    <AnimatePresence>
      {show && (
        <motion.div
          initial={{ y: 90, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          exit={{ y: 90, opacity: 0 }}
          transition={{ duration: 0.5, ease: [0.22, 1, 0.36, 1] }}
          className="fixed inset-x-4 bottom-4 z-40 md:inset-x-auto md:bottom-6 md:right-8"
        >
          <button
            data-testid="sticky-cta"
            onClick={scrollToForm}
            className="w-full rounded-full bg-mint px-8 py-4 font-display text-base font-bold text-cream shadow-[0_0_50px_rgba(0,156,222,0.45)] transition-transform duration-300 hover:scale-105 md:w-auto"
          >
            Request My Free Review →
          </button>
        </motion.div>
      )}
    </AnimatePresence>
  );
};
